export default __webpack_public_path__ + "static/logo-f9c0d6cb72cd6a9f688b5ae0cea5ce7a.png";